// extracted by css-extract-rspack-plugin
export default {"column-container":"column-container-Jid3d1","columnContainer":"column-container-Jid3d1"};